import React from "react";

import RootLoader, { RootLoaderProps } from "./components/RootLoader";
import styles from "./styles/PageLoader.module.scss";

export type PageLoaderProps = RootLoaderProps;

const PageLoader = (props: PageLoaderProps) => (
    <div className={styles.lumenoreBasePageLoaderContainer}>
        <RootLoader {...props} />
    </div>
);

export default PageLoader;
